export const BUILD_YOUR_OWN_MODULE_TEST_ID = {
  subHeadline: 'subHeadline',
};
